import React, { useContext } from 'react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import secondaryHeader from '../config/secondaryHeader'
import serverData from '../utils/server-data'
import { fptiCustomClick } from '../utils/fpti'
import { Col, Row, TabPanel, Tabs } from '@paypalcorp/pp-react'
import { string, element, number } from 'prop-types'

const SecondaryHeader = ({ children, selectedTabId, selectedTabIndex }) => {
  const worldReady = useContext(WorldReadyContext)
  const secondaryHeaderMap = secondaryHeader(serverData)
  const filteredHeader = secondaryHeaderMap.map((headerElement) => {
    return {
      ...headerElement,
      label: new MessageFormat(worldReady, {
        id: headerElement.label,
      }).format(),
    }
  })

  const handleHeaderLinksClick = (event, tabIdxClicked) => {
    fptiCustomClick(secondaryHeaderMap[tabIdxClicked].fptiClickData)
    window.location.href = secondaryHeaderMap[tabIdxClicked].link
  }

  const renderTabPanels = () =>
    secondaryHeaderMap.map(({ id, panelId, containerClass }) => (
      <TabPanel id={panelId} key={id} className={containerClass}>
        {id === selectedTabId && children}
      </TabPanel>
    ))

  return (
    <Row className="one-section-only" noGutters>
      {serverData.isNative ? (
        <Col md={{ span: 12 }}>{children}</Col>
      ) : (
        <Col id="dwColumn" md={{ span: 12 }}>
          <Tabs
            name="SecondaryHeaderLinks"
            selectedTabIdx={selectedTabIndex}
            tabs={filteredHeader}
            onClick={handleHeaderLinksClick}
            tabClassName="subHeader-tab"
            center
          >
            {renderTabPanels()}
          </Tabs>
        </Col>
      )}
    </Row>
  )
}

SecondaryHeader.propTypes = {
  selectedTabIndex: number.isRequired,
  selectedTabId: string.isRequired,
  children: element.isRequired,
}

export default SecondaryHeader
